import { createContext, useContext, useState, ReactNode } from "react";

interface DrawersContextType {
  rfqOpen: boolean;
  openRFQ: () => void;
  closeRFQ: () => void;
}

const DrawersContext = createContext<DrawersContextType | undefined>(undefined);

export const useDrawers = () => {
  const context = useContext(DrawersContext);
  if (!context) {
    throw new Error('useDrawers must be used within a DrawersProvider');
  }
  return context;
};

export const DrawersProvider = ({ children }: { children: ReactNode }) => {
  const [rfqOpen, setRfqOpen] = useState(false);

  const openRFQ = () => setRfqOpen(true);
  const closeRFQ = () => setRfqOpen(false);

  return (
    <DrawersContext.Provider
      value={{
        rfqOpen,
        openRFQ,
        closeRFQ,
      }}
    >
      {children}
    </DrawersContext.Provider>
  );
};